export enum LoginRecoveryOption {
  Username,
  CompanyName,
  Password,
}
